import React from "react";
import { reportClientError } from "../core/clientErrorReporter";

// Top-level ErrorBoundary. React-render-errors bubblen niet naar window.onerror
// dus we MOETEN een boundary plaatsen om ze op te vangen. Een class-component
// is hier de enige optie (componentDidCatch werkt niet in hooks).
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportClientError(error, { componentStack: info?.componentStack ?? "" });
  }

  handleReset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-gray-50 p-6">
          <div className="max-w-md rounded-2xl bg-white p-8 text-center shadow-sm ring-1 ring-gray-200">
            <h1 className="text-xl font-semibold text-gray-900">
              Er ging iets mis
            </h1>
            <p className="mt-2 text-sm text-gray-600">
              Het probleem is automatisch gemeld bij ons team. Probeer de pagina
              te herladen.
            </p>
            <div className="mt-6 flex justify-center gap-2">
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="rounded-md bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700"
              >
                Herlaad pagina
              </button>
              <button
                type="button"
                onClick={this.handleReset}
                className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
              >
                Doorgaan
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
